/**
 * Enumeration of the languages supported by the knowledge articles search
 */
export enum KnowledgeArticleLanguageCode {
  bg = 'bg',
  de = 'de',
  en = 'en',
  es = 'es',
  fr = 'fr',
  hu = 'hu',
  it = 'it',
  ja = 'ja',
  ko = 'ko',
  pl = 'pl',
  pt_BR = 'pt_BR',
  ru = 'ru',
  nl = 'nl',
  zh = 'zh',
}

/**
 * Defines the sort direction of the search. Defaults to asc
 */
export enum OrderOptions {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface UserInfo {
    uid: string;
    last_name: string;
    first_name: string;
    name: string;
    email: string;
    user_name: string;
    phone: string;
    mobile_phone: string;
    employee_number: string;
    employee_type: string;
    vip: string;
    photo: string;
    chosen_language: string;
    location: string;
    locationId: string;
    city: string;
    state: string;
    country: string;
    department: string;
    manager_email: string;
    manager_name: string;
    manager_uid: string;
    manager_first_name: string;
    manager_last_name: string;
    isManager?: boolean;
    locked_out?: string;
    lockedOut?: boolean;
    [properties: string] : any;
};

export interface Locale {
  [key: string]: any;
};
